<template>
  <div class="map-picker">
    <!-- 地址搜索 -->
    <el-row :gutter="20" style="margin-bottom: 20px">
      <el-col :span="24">
        <el-input

          v-model="searchAddress"

          placeholder="输入地址进行搜索"

          id="search-input"

          ref="searchInput"
        >
          <template #append>
            <el-button icon="el-icon-search" @click="handleSearch" />
          </template>
        </el-input>
      </el-col>
    </el-row>

    <!-- 坐标输入 -->
    <el-row :gutter="20">
      <el-col :span="12">
        <el-input v-model="lng" placeholder="经度">
          <template #prepend>经度</template>
        </el-input>
      </el-col>
      <el-col :span="12">
        <el-input v-model="lat" placeholder="纬度">
          <template #prepend>纬度</template>
        </el-input>
      </el-col>
    </el-row>

    <!-- 地图容器 -->
    <div id="map-container" style="height: 400px; margin-top: 20px"></div>
  </div>
</template>

<script>
  import AMapLoader from '@amap/amap-jsapi-loader'
  export default {
    props: {
      modelValue: {
        type: Object,
        default: () => ({ lng: 118.341854, lat: 35.077435 })
      },
      formData: {
        type: Object,
        default: null,
      },
    },
    data() {
      return {
        map: null,
        marker: null,
        lng: this.modelValue.lng,
        lat: this.modelValue.lat,
        searchAddress: '',
        AMap: null,
        autoComplete: null,
        geocoder: null
      }
    },
    mounted() {
      this.initMap()
    },
    methods: {
      async initMap() {
        try {
          this.AMap = await AMapLoader.load({
            key: 'a50f6a3b0f5058fa09bfbf6ad5acb4e3',
            version: '2.0',
            plugins: ['AMap.Geocoder', 'AMap.AutoComplete', 'AMap.PlaceSearch']
          })

          // 初始化地图
          this.map = new this.AMap.Map('map-container', {
            zoom: 13,
            center: [this.lng, this.lat]
          })


          // 初始化地理编码器
          this.geocoder = new this.AMap.Geocoder({
            city:'全国', // 限定搜索城市
            batch: false // 单条解析模式
          })

          // 初始化自动完成
          this.autoComplete = new this.AMap.AutoComplete({
            input: this.$refs.searchInput.$el.querySelector('input') // 获取实际的input元素

          })
          this.autoComplete.on('select', (e) => {

            this.handlePlaceSelect(e.poi)

          })

          // 初始化标记
          this.addMarker([this.lng, this.lat])

          // 点击地图事件
          this.map.on('click', (e) => {
            this.updatePosition(e.lnglat)
          })
        } catch (error) {
          console.error('地图加载失败:', error)
        }
      },

      // 地址搜索
      handleSearch() {
        console.log('00000----')
        if (!this.searchAddress.trim()) {
          this.$message.warning('请输入有效地址')
          return
        }

        this.geocoder.getLocation(this.searchAddress, (status, result) => {
          console.log('解析结果:', '0000----')
          if (status === 'complete' && result.geocodes.length > 0) {
            const bestMatch = result.geocodes[0]
            console.log('解析结果:', bestMatch)

            this.searchAddress = bestMatch.formattedAddress // 标准化地址
            this.updatePosition({
              lng: bestMatch.location.lng,
              lat: bestMatch.location.lat
            })
          } else {
            this.$message.error('地址解析失败，请检查输入')
            console.error('地理编码错误:', result)
          }
        })

      },

      // 地点选择（自动完成）
      handlePlaceSelect(poi) {
        if (!poi.location) return
        this.searchAddress = poi.name
        this.updatePosition({
          lng: poi.location.lng,
          lat: poi.location.lat
        })
      },

      // 更新坐标位置
      updatePosition(lnglat) {
        this.lng = lnglat.lng.toFixed(6)
        this.lat = lnglat.lat.toFixed(6)
        this.addMarker([this.lng, this.lat])
        // this.formData.lng=this.lng;
        // this.formData.lat=this.lat;
        this.emitUpdate()
        this.map.setCenter([this.lng, this.lat])
        // 在 updatePosition 方法中添加
        // this.geocoder.getAddress([lnglat.lng, lnglat.lat], (status, result) => {
        //   if (status === 'complete') {
        //     this.searchAddress = result.regeocode.formattedAddress
        //   }
        // })

      },

      // 添加标记
      addMarker(position) {
        if (this.marker) {
          this.map.remove(this.marker)
        }
        this.marker = new this.AMap.Marker({
          position: position,
          map: this.map
        })
      },

      // 触发更新
      emitUpdate() {
        this.$emit('update:modelValue', {
          lng: parseFloat(this.lng),
          lat: parseFloat(this.lat)
        })
      }
    }
  }
</script>
